/**
 * VLearn API Client + Socket.io connector
 */
const BASE = process.env.REACT_APP_API_URL || "https://vlearn-render.onrender.com";

function getToken() { return localStorage.getItem("vlearn_token"); }

async function req(method, path, body) {
  const headers = { "Content-Type": "application/json" };
  const token = getToken();
  if (token) headers["Authorization"] = `Bearer ${token}`;
  const res = await fetch(`${BASE}${path}`, {
    method, headers, body: body ? JSON.stringify(body) : undefined,
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: "Request failed" }));
    throw new Error(err.error || `HTTP ${res.status}`);
  }
  return res.json();
}

export const api = {
  /* Auth */
  login:    (email, pass) => req("POST", "/api/auth/login", { email, pass }),
  register: (data)        => req("POST", "/api/auth/register", data),

  /* Students */
  getStudents:   ()       => req("GET",    "/api/students"),
  getStudent:    (id)     => req("GET",    `/api/students/${id}`),
  addStudent:    (data)   => req("POST",   "/api/students", data),
  updateStudent: (id, d)  => req("PUT",    `/api/students/${id}`, d),
  deleteStudent: (id)     => req("DELETE", `/api/students/${id}`),
  linkParent:    (sid, pid) => req("PATCH", `/api/students/${sid}/link-parent`, { parent_id: pid }),

  /* Attendance */
  getAttendance:  (p={}) => req("GET", `/api/attendance${new URLSearchParams(p).toString() ? "?"+new URLSearchParams(p) : ""}`),
  markAttendance: (records) => req("POST", "/api/attendance", { records }),

  /* Tests */
  getTests:  (sid) => req("GET", `/api/tests${sid ? `?student_id=${sid}` : ""}`),
  addTest:   (d)   => req("POST",   "/api/tests", d),
  deleteTest:(id)  => req("DELETE", `/api/tests/${id}`),

  /* Fees */
  updateFeeStatus:    (id, status) => req("PUT", `/api/students/${id}/fee`, { fee_status: status }),
  getFeeStructure:    ()           => req("GET", "/api/fee-structure"),
  updateFeeStructure: (structure)  => req("PUT", "/api/fee-structure", { structure }),

  /* Notices */
  getNotices:   ()     => req("GET",    "/api/notices"),
  addNotice:    (d)    => req("POST",   "/api/notices", d),
  deleteNotice: (id)   => req("DELETE", `/api/notices/${id}`),

  /* Users */
  getUsers:    ()   => req("GET",    "/api/users"),
  approveUser: (id) => req("PUT",    `/api/users/${id}/approve`),
  updateUser:  (id, d) => req("PUT", `/api/users/${id}`, d),
  deleteUser:  (id) => req("DELETE", `/api/users/${id}`),

  /* Enquiries */
  submitEnquiry:  (d)   => req("POST",   "/api/enquiries", d),
  getEnquiries:   ()    => req("GET",    "/api/enquiries"),
  updateEnquiry:  (id,d)=> req("PUT",    `/api/enquiries/${id}`, d),
  deleteEnquiry:  (id)  => req("DELETE", `/api/enquiries/${id}`),

  /* Home CMS */
  getHome:           ()    => req("GET",    "/api/home"),
  updateHome:        (d)   => req("PUT",    "/api/home", d),
  addGalleryImage:   (d)   => req("POST",   "/api/gallery", d),
  deleteGalleryImage:(id)  => req("DELETE", `/api/gallery/${id}`),

  /* Stats */
  getStats: () => req("GET", "/api/stats"),
};

/* ─── SOCKET.IO REAL-TIME ─── */
let socket = null;

export function connectSocket(userId, role, handlers = {}) {
  import("socket.io-client").then(({ io }) => {
    if (socket) socket.disconnect();
    socket = io(BASE, { transports: ["websocket","polling"] });
    socket.on("connect", () => { socket.emit("identify", { userId, role }); });
    const events = [
      "student_added","student_updated","student_deleted",
      "attendance_marked","marks_added","marks_deleted",
      "fee_updated","fee_structure_updated",
      "notice_posted","notice_deleted",
      "user_approved","user_deleted","users_updated",
      "home_updated","gallery_updated",
      "enquiry_received",
    ];
    events.forEach(e => { if (handlers[e]) socket.on(e, handlers[e]); });
  });
  return () => socket?.disconnect();
}

export function disconnectSocket() {
  socket?.disconnect();
  socket = null;
}
